import React, {Component} from 'react';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import ComponentReactTable, {PartsDataJSON} from "./ComponentsReactTable";
import {DialogActions} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
//@ts-ignore
import ApiManager from "hcla-web-frontend-primitives/app/Api/ApiManager";

interface Props {
    open: boolean;
    toggleDialog: () => void;
    doSet: (e: React.SyntheticEvent<{}, Event>, selectedPart: PartsDataJSON) => void;
}

interface State {
    items: PartsDataJSON | null;
    itemTotal: number| null;
    paginationEnabled: boolean;
    isLoading: true;
    selectedPart: PartsDataJSON | null;
}

class PartsPickerDialog extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            items: null,
            itemTotal: null,
            paginationEnabled: false,
            isLoading: true,
            selectedPart: null,
        }
    }

    componentDidMount(): void {
        this.fetchData(5, 0);
    }

    fetchData = (limit: number, offset: number) => {
        this.setState({isLoading: true }, () => {
            ApiManager.getComponents(limit, offset)
              .then(response => response.json())
              .then(data => this.setState({
                  items: data && data.results ? data.results : data,
                  itemTotal: data && data.count ? data.count : null,
                  paginationEnabled: !!(data && data.results),
                  isLoading: false
              }));
        })
    };

    handleUpdateSelectedPart = (selectedPart: PartsDataJSON) => this.setState({ selectedPart });

    doSet = (e: React.SyntheticEvent<{}, Event>) => {
        const { doSet } = this.props;
        const { selectedPart } = this.state;
        doSet(e, selectedPart);
        this.handleClose();
    };

    handleClose = () => {
        const { toggleDialog } = this.props;
        toggleDialog();
        this.setState({selectedPart: null});
    };

    render() {
        const { open } = this.props;
        const { items, itemTotal, paginationEnabled, isLoading, selectedPart } = this.state;

        return (
            <Dialog
                fullWidth
                maxWidth="lg"
                open={open}
                disableEnforceFocus
            >
                <DialogTitle>Select a Part to Link</DialogTitle>
                <DialogContent>
                  <ComponentReactTable
                    data={items}
                    dataTotal={itemTotal}
                    paginationEnabled={paginationEnabled}
                    isLoading={isLoading}
                    fetchData={this.fetchData}
                    isPicker
                    doUpdateSelectedPart={this.handleUpdateSelectedPart}
                  />
                </DialogContent>
                <DialogActions>
                    <Button
                        fullWidth
                        variant="contained"
                        tabIndex={-1}
                        onClick={this.handleClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={selectedPart === null}
                        onClick={this.doSet}
                    >
                        Set
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default PartsPickerDialog;
